import axios from 'axios';

// API configuration
const DEFAULT_DEV_URL = 'http://localhost:3000'
const DEFAULT_PROD_URL = 'https://wurlolanding.onrender.com'

export const API_BASE_URL = (() => {
  const envUrl = import.meta.env?.VITE_API_BASE_URL
  if (envUrl) return envUrl.replace(/\/?$/, '')
  const fallback = import.meta.env?.PROD ? DEFAULT_PROD_URL : DEFAULT_DEV_URL
  return fallback.replace(/\/?$/, '')
})()

const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/`,
  headers: { 'Content-Type': 'application/json' },
  timeout: 300000
})

// Content moderation
export async function moderateContent(goal, experience) {
  try {
    const response = await apiClient.post('/api/moderate', { goal, experience })
    return response.data
  } catch (error) {
    console.error('Moderation Error:', error.response?.data || error.message)
    throw new Error(error.response?.data?.error?.message || error.message)
  }
}

// Call Gemini AI
export async function callGeminiAPI(goal, experience) {
  try {
    const response = await apiClient.post('/api/gemini', { goal, experience })
    return response.data
  } catch (error) {
    console.error('Gemini API Error:', error.response?.data || error.message)
    throw new Error(error.response?.data?.error?.message || error.message)
  }
}

// Get remaining beta spots
export async function getSpotsRemaining() {
  try {
    const response = await apiClient.get('/api/spots-remaining')
    return response.data.remaining || 20
  } catch (error) {
    console.warn('Could not fetch spots:', error)
    return 20
  }
}

// Get platform stats
export async function getStats() {
  try {
    const response = await apiClient.get('/api/stats')
    return response.data
  } catch (error) {
    console.warn('Could not fetch stats:', error)
    return { userCount: 0, reviewCount: 0, avgRating: 0 }
  }
}

// Get user reviews
export async function getReviews() {
  try {
    const response = await apiClient.get('/api/reviews')
    return response.data.reviews || []
  } catch (error) {
    console.warn('Could not load reviews:', error)
    return []
  }
}

// Create Stripe checkout
export async function createCheckout(email, options = {}) {
  try {
    const response = await apiClient.post('/api/create-checkout', { email, ...options })
    if (!response.data.url) throw new Error('No checkout URL received')
    return response.data.url
  } catch (error) {
    console.error('Checkout Error:', error.response?.data || error.message)
    throw new Error(error.response?.data?.message || 'Failed to create checkout')
  }
}

// Join mailing list
export async function joinMailingList(email, options = {}) {
  try {
    const response = await apiClient.post('/api/mailing-list', { email, ...options })
    return response.data
  } catch (error) {
    console.error('Mailing List Error:', error.response?.data || error.message)
    throw new Error(error.response?.data?.message || 'Failed to join mailing list')
  }
}

// Join waitlist
export async function joinWaitlist(userData) {
  try {
    const response = await apiClient.post('/api/join-waitlist', userData)
    return response.data
  } catch (error) {
    console.error('Waitlist Error:', error.response?.data || error.message)
    throw new Error(error.response?.data?.message || 'Failed to join waitlist')
  }
}

export default apiClient
